import React, { useState, useEffect } from 'react'

// Deps
import config from 'config'

// Partials
import Dropdown from 'views/shared/partials/dropdown'
import { Table, TR, TD } from 'views/shared/partials/table'
import Loader from 'views/shared/partials/loader'
import Image from 'views/shared/partials/image'
import Btn from 'views/shared/partials/btn'

// Utils
import { openModal } from 'utils/modals';

// Sections
import Breadcrumbs from 'views/admin/sections/breadcrumbs'

// Services
import companyServices from 'services/company'
import formatDate from 'functions/format-date'

const Announcements = (props) => {
	const [data, setData] = useState(false);

	const getAnnouncements = () => {
		setData(false);
		companyServices.getAnnouncements().then((payload) => {
			setData(payload)
		})
	}

	const deleteAnnouncement = (announcement) => {
		openModal(
			'confirm',
			{
				message: announcement.title + ' başlıklı bildirimi silmek istediğinizden emin misiniz?',
				onConfirm: () => {
					setData(false);
					companyServices.deleteAnnouncement(announcement.id).then(() => {
						getAnnouncements();
					}).catch(() => {});
				}
			}
		)
	}

	useEffect(() => {
		getAnnouncements();
	}, [])

	return (
		<main className="page company-payment-types">
			<Breadcrumbs />
			<section className="portlet section types-list">
				<div className="portlet-header">
					<strong className="portlet-title">Duyurular</strong>

					<div className="header-controls">
						<Btn
							white small wide
							onClick={() => {
								openModal(
									'announcement',
									{
										onSuccess: () => { getAnnouncements(); }
									}
								);
							}}
							icon="plus">
							Yeni Duyuru Oluştur
						</Btn>
					</div>
				</div>

				<div className="portlet-section bottom loader-container">
					<Loader loading={!data} />

					{(data) &&
						<Table 
							emptyMessage="Hiç ödeme bulunmuyor."
							className="list-table"
							heading={
								<React.Fragment>
									<th>Görsel</th>
									<th>Başlık</th>
									<th>Mesaj</th>
									<th>Oluşturulma Tarihi</th>
									<th></th>
								</React.Fragment>
							}>
							
							{data.map((announcement, nth) => (
								<TR key={nth} mobileTitle={announcement.title}>
									<TD>
										<div className="table-imagewrap">
											<Image bg src={announcement.image ? config.cdnUrl + 'announcement_images/' + announcement.image : false} />
										</div>
									</TD>
									<TD hideMobile>
										{announcement.title}
									</TD>
									<TD mobileTitle="Mesaj">
										{announcement.description}
									</TD>
									<TD mobileTitle="Oluşturulma Tarihi">
										{formatDate(announcement.created_at)}
									</TD>
									<TD className="controls">
										<Dropdown
											text="İşlemler"
											icon="list">
											<button
												onClick={() => {
													openModal('announcement', {announcement: announcement, onSuccess: () => { getAnnouncements(); }})
												}}>
												Düzenle
											</button>
											<button
												className="error"
												onClick={() => {
													deleteAnnouncement(announcement);
												}}>
												Sil
											</button>
										</Dropdown>
									</TD>
								</TR>
							))}
						</Table>
					}
				</div>
			</section>
		</main>
	)
}

export default Announcements